(function($) {$(document).ready(function() {

	const $slider = $('.home-3up-links__inner').flickity({
		wrapAround: true,
		imagesLoaded: true,
		cellSelector: '.home-3up-links__item',
		prevNextButtons: false,
		pageDots: false,
		watchCSS: true
	});

	$('.home-3up-links__arrow.left').on('click', event => $slider.flickity('previous'));
	$('.home-3up-links__arrow.right').on('click', event => $slider.flickity('next'));

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);